<div class="p-6">

  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Synchronizacja KSeF</h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Historia uruchomień CRON i status synchronizacji użytkowników</p>
    </div>
    <div class="flex items-center gap-2">
      <button mat-stroked-button (click)="toggleDiagnosePanel()" class="flex items-center gap-2"
              [class.!border-blue-500]="showDiagnosePanel" [class.!text-blue-600]="showDiagnosePanel">
        <mat-icon [svgIcon]="'tabler_outline:stethoscope'"></mat-icon>
        Diagnozuj
      </button>
      <button mat-flat-button color="primary" (click)="triggerManualSync()" [disabled]="isTriggeringSync || isRefreshing" class="flex items-center gap-2">
        <mat-icon *ngIf="!isTriggeringSync" [svgIcon]="'tabler_outline:player-play'"></mat-icon>
        <mat-spinner *ngIf="isTriggeringSync" [diameter]="18" class="mr-1"></mat-spinner>
        {{ isTriggeringSync ? 'Uruchamianie...' : 'Uruchom synchronizację' }}
      </button>
      <button mat-stroked-button (click)="refresh()" [disabled]="isRefreshing" class="flex items-center gap-2">
        <mat-icon [class.animate-spin]="isRefreshing" [svgIcon]="'tabler_outline:refresh'"></mat-icon>
        Odśwież
      </button>
    </div>
  </div>

  <!-- Sync Trigger Result -->
  <div *ngIf="syncTriggerResult" class="mb-4 rounded-xl border p-4 flex items-start gap-3"
       [ngClass]="{
         'bg-green-50 border-green-200 dark:bg-green-950/20 dark:border-green-800': syncTriggerResult.triggered,
         'bg-amber-50 border-amber-200 dark:bg-amber-950/20 dark:border-amber-800': !syncTriggerResult.triggered && syncTriggerResult.reason === 'already_processing',
         'bg-red-50 border-red-200 dark:bg-red-950/20 dark:border-red-800': !syncTriggerResult.triggered && syncTriggerResult.reason === 'error'
       }">
    <mat-icon class="flex-shrink-0 mt-0.5"
              [ngClass]="{
                'text-green-600 dark:text-green-400': syncTriggerResult.triggered,
                'text-amber-600 dark:text-amber-400': !syncTriggerResult.triggered && syncTriggerResult.reason === 'already_processing',
                'text-red-600 dark:text-red-400': !syncTriggerResult.triggered && syncTriggerResult.reason === 'error'
              }"
              [svgIcon]="syncTriggerResult.triggered ? 'tabler_outline:circle-check' : (syncTriggerResult.reason === 'already_processing' ? 'tabler_outline:clock-pause' : 'tabler_outline:alert-triangle')">
    </mat-icon>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium"
         [ngClass]="{
           'text-green-800 dark:text-green-300': syncTriggerResult.triggered,
           'text-amber-800 dark:text-amber-300': !syncTriggerResult.triggered && syncTriggerResult.reason === 'already_processing',
           'text-red-800 dark:text-red-300': !syncTriggerResult.triggered && syncTriggerResult.reason === 'error'
         }">
        {{ syncTriggerResult.message }}
      </p>
    </div>
    <button mat-icon-button (click)="dismissSyncResult()" class="flex-shrink-0 -mt-1 -mr-1">
      <mat-icon class="icon-size-4 text-gray-400" [svgIcon]="'tabler_outline:x'"></mat-icon>
    </button>
  </div>

  <!-- ===================== -->
  <!-- Diagnozuj Panel       -->
  <!-- ===================== -->
  <div *ngIf="showDiagnosePanel" class="mb-6 bg-white dark:bg-gray-800 rounded-xl border border-blue-200 dark:border-blue-800 overflow-hidden">
    <div class="p-4 border-b border-blue-100 dark:border-blue-900/50 bg-blue-50/50 dark:bg-blue-950/20">
      <div class="flex items-center gap-3">
        <mat-icon class="text-blue-600 dark:text-blue-400" [svgIcon]="'tabler_outline:stethoscope'"></mat-icon>
        <div class="flex-1">
          <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Diagnostyka synchronizacji</h3>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Uruchom synchronizację dla konkretnego użytkownika i przeanalizuj logi</p>
        </div>
        <button mat-icon-button (click)="toggleDiagnosePanel()" class="flex-shrink-0">
          <mat-icon class="icon-size-4 text-gray-400" [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
      </div>
    </div>
    <div class="p-4">
      <div class="flex items-center gap-3">
        <div class="flex-1">
          <input type="text"
                 [(ngModel)]="diagnoseNip"
                 (keydown.enter)="runDiagnose()"
                 placeholder="Wpisz NIP użytkownika (np. 5555555555)"
                 class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono">
        </div>
        <button mat-flat-button color="primary" (click)="runDiagnose()" [disabled]="isDiagnosing || !diagnoseNip.trim()" class="flex items-center gap-2 flex-shrink-0">
          <mat-spinner *ngIf="isDiagnosing" [diameter]="18" class="mr-1"></mat-spinner>
          <mat-icon *ngIf="!isDiagnosing" [svgIcon]="'tabler_outline:player-play'"></mat-icon>
          {{ isDiagnosing ? 'Diagnostyka...' : 'Uruchom' }}
        </button>
      </div>

      <!-- Diagnose Results -->
      <div *ngIf="diagnoseLogLines.length > 0" class="mt-4">
        <div class="flex items-center gap-2 mb-2">
          <mat-icon *ngIf="diagnoseSuccess === true" class="icon-size-5 text-green-600 dark:text-green-400" [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
          <mat-icon *ngIf="diagnoseSuccess === false" class="icon-size-5 text-red-600 dark:text-red-400" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
          <span class="text-sm font-medium" [ngClass]="diagnoseSuccess ? 'text-green-700 dark:text-green-300' : 'text-red-700 dark:text-red-300'">
            {{ diagnoseSuccess ? 'Synchronizacja zakończona pomyślnie' : 'Synchronizacja zakończona z błędem' }}
          </span>
        </div>
        <div class="bg-gray-900 rounded-lg overflow-auto p-4" style="max-height: 500px;">
          <pre class="text-[13px] leading-relaxed font-mono whitespace-pre-wrap text-gray-300 m-0"><ng-container *ngFor="let logLine of diagnoseLogLines"><span [ngClass]="getLogLineClass(logLine.level)">{{logLine.text}}</span>
</ng-container></pre>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-20">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading">

    <!-- ===================== -->
    <!-- Summary Cards         -->
    <!-- ===================== -->
    <div *ngIf="summary" class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Aktywne połączenia</p>
        <p class="text-2xl font-bold text-gray-900 dark:text-white mt-1">{{ summary.totalConnections }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Z błędami</p>
        <p class="text-2xl font-bold mt-1" [class]="summary.withErrors > 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'">
          {{ summary.withErrors }}
        </p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Przestarzałe</p>
        <p class="text-2xl font-bold mt-1" [class]="summary.stale > 0 ? 'text-amber-600 dark:text-amber-400' : 'text-green-600 dark:text-green-400'">
          {{ summary.stale }}
        </p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Nigdy sync.</p>
        <p class="text-2xl font-bold mt-1" [class]="summary.neverSynced > 0 ? 'text-gray-600 dark:text-gray-400' : 'text-green-600 dark:text-green-400'">
          {{ summary.neverSynced }}
        </p>
      </div>
    </div>

    <!-- ===================== -->
    <!-- CRON History           -->
    <!-- ===================== -->
    <div class="mb-8">
      <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
        <mat-icon class="text-blue-600 dark:text-blue-400" [svgIcon]="'tabler_outline:clock'"></mat-icon>
        Historia uruchomień CRON
      </h3>

      <div *ngIf="cronLogs.length === 0" class="text-sm text-gray-500 dark:text-gray-400 py-8 text-center">
        Brak logów CRON
      </div>

      <div *ngIf="cronLogs.length > 0" class="space-y-2">
        <div *ngFor="let log of cronLogs" 
             class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 transition-colors hover:border-gray-300 dark:hover:border-gray-600">
          <div class="flex items-start gap-3">
            <!-- Icon -->
            <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                 [ngClass]="{
                   'bg-blue-100 dark:bg-blue-900/30': log.logType === 'cron_started',
                   'bg-green-100 dark:bg-green-900/30': log.logType === 'cron_completed' && log.status !== 'warning',
                   'bg-amber-100 dark:bg-amber-900/30': log.logType === 'cron_completed' && log.status === 'warning',
                   'bg-red-100 dark:bg-red-900/30': log.logType === 'cron_failed',
                   'bg-gray-100 dark:bg-gray-700': log.logType === 'cron_skipped'
                 }">
              <mat-icon class="icon-size-5" [ngClass]="getCronIconClass(log.logType, log.status)" [svgIcon]="getCronIcon(log.logType)"></mat-icon>
            </div>

            <!-- Content -->
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-semibold text-sm text-gray-900 dark:text-white">{{ getCronLabel(log.logType) }}</span>
                <span *ngIf="log.data?.cronType" class="px-2 py-0.5 text-[10px] uppercase tracking-wide rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 font-medium">
                  {{ log.data.cronType }}
                </span>
                <span class="text-xs text-gray-400 dark:text-gray-500 ml-auto flex-shrink-0">
                  {{ formatRelativeDate(log.timestamp) }}
                </span>
              </div>

              <!-- Stats for CRON_COMPLETED -->
              <div *ngIf="log.logType === 'cron_completed' && log.data" class="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs">
                <span class="text-gray-600 dark:text-gray-400">
                  <span class="font-medium text-gray-900 dark:text-white">{{ log.data.usersProcessed }}</span> użytkowników
                </span>
                <span class="text-gray-600 dark:text-gray-400">
                  <span class="font-medium text-gray-900 dark:text-white">{{ log.data.totalInvoices || 0 }}</span> faktur
                </span>
                <span class="text-green-600 dark:text-green-400">
                  <span class="font-medium">{{ log.data.successCount }}</span> OK
                </span>
                <span *ngIf="log.data.failedCount && log.data.failedCount > 0" class="text-red-600 dark:text-red-400 font-medium">
                  {{ log.data.failedCount }} FAILED
                </span>
                <span *ngIf="log.data.skippedNoSubscription && log.data.skippedNoSubscription > 0" class="text-amber-600 dark:text-amber-400 font-medium">
                  {{ log.data.skippedNoSubscription }} pominięto (brak subskrypcji)
                </span>
                <span class="text-gray-500 dark:text-gray-400">
                  {{ formatDuration(log.data.duration) }}
                </span>
              </div>

              <!-- Failed Users -->
              <div *ngIf="log.data?.failedUsers?.length" class="mt-2 space-y-1">
                <div *ngFor="let fu of log.data.failedUsers" class="flex items-start gap-2 text-xs bg-red-50 dark:bg-red-950/20 rounded-lg px-3 py-1.5">
                  <mat-icon class="text-red-500 !w-3.5 !h-3.5 flex-shrink-0 mt-0.5" [svgIcon]="'tabler_outline:x'"></mat-icon>
                  <span class="text-red-800 dark:text-red-300">
                    <span class="font-medium">{{ fu.userLabel }}</span>
                    <span class="text-red-600 dark:text-red-400 ml-1">{{ fu.error }}</span>
                  </span>
                </div>
              </div>

              <!-- Reason (for skipped) -->
              <p *ngIf="log.data?.reason" class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ log.data.reason }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== -->
    <!-- User Sync Status      -->
    <!-- ===================== -->
    <div>
      <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
        <mat-icon class="text-purple-600 dark:text-purple-400" [svgIcon]="'tabler_outline:users'"></mat-icon>
        Status synchronizacji użytkowników
      </h3>

      <div *ngIf="connections.length === 0" class="text-sm text-gray-500 dark:text-gray-400 py-8 text-center">
        Brak aktywnych połączeń z KSeF
      </div>

      <div *ngIf="connections.length > 0" class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-gray-200 dark:border-gray-700">
              <th class="text-left py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Użytkownik</th>
              <th class="text-left py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">NIP</th>
              <th class="text-center py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">CRON</th>
              <th class="text-left py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Status</th>
              <th class="text-left py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Ostatnia sync</th>
              <th class="text-right py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Faktury</th>
              <th class="text-left py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Czas trwania</th>
              <th class="text-left py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Błąd</th>
              <th class="text-center py-3 px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let conn of connections" 
                class="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
              <td class="py-3 px-3">
                <div class="font-medium text-gray-900 dark:text-white">{{ conn.userEmail }}</div>
                <div *ngIf="conn.companyName" class="text-xs text-gray-500 dark:text-gray-400">{{ conn.companyName }}</div>
              </td>
              <td class="py-3 px-3 text-gray-600 dark:text-gray-400 font-mono text-xs">{{ conn.nip }}</td>
              <td class="py-3 px-3 text-center">
                <mat-icon *ngIf="conn.isEligibleForCron" class="icon-size-4 text-green-600 dark:text-green-400"
                          [svgIcon]="'tabler_outline:circle-check'"
                          [matTooltip]="'CRON aktywny (' + (conn.connectionType || 'token') + ')'">
                </mat-icon>
                <mat-icon *ngIf="!conn.isEligibleForCron" class="icon-size-4 text-amber-500 dark:text-amber-400"
                          [svgIcon]="'tabler_outline:alert-triangle'"
                          [matTooltip]="'Pomijany przez CRON — brak uprawnienia InvoiceRead i nie jest certyfikat'">
                </mat-icon>
              </td>
              <td class="py-3 px-3">
                <span class="px-2 py-1 rounded-full text-xs font-medium" [ngClass]="getStatusClass(conn.status)">
                  {{ getStatusLabel(conn.status) }}
                </span>
              </td>
              <td class="py-3 px-3 text-gray-600 dark:text-gray-400">
                {{ conn.timeSinceLastSync }}
              </td>
              <td class="py-3 px-3 text-right text-gray-900 dark:text-white font-medium">{{ conn.lastSyncInvoicesCount }}</td>
              <td class="py-3 px-3 text-gray-500 dark:text-gray-400">{{ conn.lastSyncDuration || '—' }}</td>
              <td class="py-3 px-3">
                <div *ngIf="conn.lastSyncError">
                  <span class="text-xs text-red-600 dark:text-red-400 break-all max-w-xs block" [matTooltip]="conn.lastSyncError">
                    {{ conn.lastSyncError.length > 80 ? conn.lastSyncError.substring(0, 80) + '...' : conn.lastSyncError }}
                  </span>
                  <span *ngIf="conn.lastSyncErrorAt" class="text-[10px] text-gray-400 dark:text-gray-500">
                    {{ formatRelativeDate(conn.lastSyncErrorAt) }}
                  </span>
                </div>
                <span *ngIf="!conn.lastSyncError && conn.status === 'never' && !conn.isEligibleForCron" 
                      class="text-xs text-amber-600 dark:text-amber-400">
                  Brak uprawnień do sync
                </span>
                <span *ngIf="!conn.lastSyncError && (conn.status !== 'never' || conn.isEligibleForCron)" class="text-xs text-gray-400">—</span>
              </td>
              <td class="py-3 px-3 text-center">
                <button mat-icon-button (click)="diagnoseFromTable(conn.nip)" [matTooltip]="'Diagnozuj synchronizację'" class="!w-8 !h-8">
                  <mat-icon class="icon-size-4 text-blue-600 dark:text-blue-400" [svgIcon]="'tabler_outline:stethoscope'"></mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </ng-container>
</div>
